import React, {useState} from "react";
import ApiCard from "../components/ApiCard";
export default function ServiceTest() {
    const [facilityId, setFacilityId] = useState("");
    const [facilityName, setFacilityName] = useState("");
    const [bridgeId, setBridgeId] = useState("");
    const [hipName, setHipName] = useState("");
    const [type, setType] = useState("");
    const [active, setActive] = useState(false);
    const payload = {
        facilityId: facilityId, facilityName: facilityName, HRP: [{
            bridgeId: bridgeId, hipName: hipName, type: type, active: active
        }]
    };
    return (<>

        {/* =====================================================
                HOSPITAL / FACILITY DETAILS
            ===================================================== */}

        <div className="card shadow-sm mb-4">

            <div className="card-header bg-primary text-white">

                <strong>
                    Add / Update ABDM Service
                </strong>

            </div>

            <div className="card-body">

                <div className="row">

                    {/* FACILITY ID */}

                    <div className="col-md-6 mb-3">

                        <label className="form-label fw-bold">
                            Facility ID
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            value={facilityId}
                            onChange={(e) => setFacilityId(e.target.value)}
                            placeholder="Enter Facility ID"
                        />

                    </div>


                    {/* FACILITY NAME */}

                    <div className="col-md-6 mb-3">

                        <label className="form-label fw-bold">
                            Facility Name
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            value={facilityName}
                            onChange={(e) => setFacilityName(e.target.value)}
                            placeholder="Enter Facility Name"
                        />

                    </div>


                    {/* BRIDGE ID */}

                    <div className="col-md-6 mb-3">

                        <label className="form-label fw-bold">
                            Bridge ID
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            value={bridgeId}
                            onChange={(e) => setBridgeId(e.target.value)}
                            placeholder="Enter Bridge ID"
                        />

                    </div>


                    {/* HIP NAME */}

                    <div className="col-md-6 mb-3">

                        <label className="form-label fw-bold">
                            HIP Name
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            value={hipName}
                            onChange={(e) => setHipName(e.target.value)}
                            placeholder="Enter HIP Name"
                        />

                    </div>


                    {/* TYPE */}

                    <div className="col-md-6 mb-3">

                        <label className="form-label fw-bold">
                            Type
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            placeholder="Enter Type"
                        />

                    </div>


                    {/* ACTIVE */}

                    <div className="col-md-6 mb-3">

                        <label className="form-label fw-bold">
                            Active
                        </label>

                        <div className="form-check mt-2">

                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={active}
                                onChange={(e) => setActive(e.target.checked)}
                                id="serviceActive"
                            />

                            <label
                                className="form-check-label"
                                htmlFor="serviceActive"
                            >
                                Active
                            </label>

                        </div>

                    </div>

                </div>

            </div>

        </div>


        {/* =====================================================
                API CARD
            ===================================================== */}

        <ApiCard
            title="Add / Update Services"
            description="Send the entered facility details to ABDM"
            url="abdm/add-services/"
            method="POST"
            payload={payload}
            buttonText="Add / Update Services"
        />


        {/* =====================================================
                GET SERVICES
            ===================================================== */}

        <ApiCard
            title="Get Services"
            description="Get Registered Services"
            url="abdm/get-services/"
            method="GET"
            buttonText="Get Services"
        />

    </>);
}